import { Stack, Table, Text } from "@mantine/core";
import type { AssistantUsageText } from "@/locales/assistant-usage";
import type { UsageModelRowDto, UsagePeriod } from "@/types/ai-assistant-usage";
import { formatMinutes, formatNumber, formatUsd } from "./cap.logic";

interface Props {
	rows: UsageModelRowDto[];
	period: UsagePeriod;
	t: AssistantUsageText;
	lang: "id" | "en";
}

/** Rincian pemakaian per model untuk satu periode; model tanpa tarif ditandai. */
export function CapModelTable({ rows, period, t, lang }: Props) {
	const mine = rows.filter((r) => r.period === period);
	if (mine.length === 0)
		return (
			<Text size="sm" c="dimmed">
				{t.modelsEmpty}
			</Text>
		);
	return (
		<Stack gap="xs" data-usage-models={period}>
			<Table.ScrollContainer minWidth={560}>
				<Table withRowBorders verticalSpacing="xs" fz="sm">
					<Table.Thead>
						<Table.Tr>
							<Table.Th>{t.colModel}</Table.Th>
							<Table.Th>{t.colType}</Table.Th>
							<Table.Th ta="right">{t.colInput}</Table.Th>
							<Table.Th ta="right">{t.colOutput}</Table.Th>
							<Table.Th ta="right">{t.colMinutes}</Table.Th>
							<Table.Th ta="right">{t.colRequests}</Table.Th>
							<Table.Th ta="right">{t.colUsd}</Table.Th>
						</Table.Tr>
					</Table.Thead>
					<Table.Tbody>
						{mine.map((r) => (
							<Table.Tr key={`${r.kind}:${r.model}`}>
								<Table.Td>{r.model}</Table.Td>
								<Table.Td>{r.kind === "chat" ? t.chat : t.voice}</Table.Td>
								<Table.Td ta="right">
									{r.kind === "chat" ? formatNumber(r.inputTokens, lang) : "-"}
								</Table.Td>
								<Table.Td ta="right">
									{r.kind === "chat" ? formatNumber(r.outputTokens, lang) : "-"}
								</Table.Td>
								<Table.Td ta="right">
									{r.kind === "voice"
										? formatMinutes(r.voiceSeconds, lang)
										: "-"}
								</Table.Td>
								<Table.Td ta="right">{formatNumber(r.requests, lang)}</Table.Td>
								<Table.Td ta="right">
									{r.usd === null ? (
										<Text span size="xs" c="orange">
											{t.rateMissing}
										</Text>
									) : (
										formatUsd(r.usd, lang)
									)}
								</Table.Td>
							</Table.Tr>
						))}
					</Table.Tbody>
				</Table>
			</Table.ScrollContainer>
		</Stack>
	);
}
